exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".conway-grid-overlay[data-v-8840d0a2]{position:relative}", ""]);

// exports
